import { Link } from "react-router-dom";

export default function Footer() {
  return (
    <footer id="iletisim" className="bg-[#1a1a1a] text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Company Info */}
          <div>
            <div className="flex items-center gap-3 mb-6">
              <img
                src="https://static.readdy.ai/image/e51399e73e35a4762b4f070880195b49/9b2e9a7aaab42a3100a70bae259ec8cb.jpeg"
                alt="Rota Berlin Logo"
                className="h-12 w-auto object-contain"
              />
              <div className="text-sm text-gray-400">Eğitim Danışmanlığı</div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed">
              Almanya'da eğitim hayalinizi gerçekleştirmeniz için profesyonel danışmanlık hizmeti sunuyoruz. Lisans, yüksek lisans ve dil okulu başvurularında yanınızdayız.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Hızlı Linkler</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Ana Sayfa</Link></li>
              <li><Link to="/about" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Hakkımızda</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Hizmetlerimiz</Link></li>
              <li><Link to="/contact" className="text-gray-400 hover:text-[#FFCE00] transition-colors">İletişim</Link></li>
              <li><a href="#randevu" className="text-gray-400 hover:text-[#FFCE00] transition-colors cursor-pointer">Randevu Al</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">Hizmetlerimiz</h3>
            <ul className="space-y-3">
              <li><Link to="/services" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Lisans Programları</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Yüksek Lisans</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Dil Okulu</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Bloke Hesap</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Konaklama Desteği</Link></li>
              <li><Link to="/services" className="text-gray-400 hover:text-[#FFCE00] transition-colors">Havalimanı Karşılama</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-lg font-bold text-white mb-6">İletişim</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#DD0000]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-map-pin-line text-[#FFCE00]"></i>
                </div>
                <div className="text-sm text-gray-400">
                  <strong className="text-gray-300">Türkiye:</strong><br />
                  Esentepe M. Mithat Ulu Ünlü S.<br />
                  No: 26/26 Şişli / İstanbul
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#DD0000]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-phone-line text-[#FFCE00]"></i>
                </div>
                <div>
                  <a href="tel:+902129126797" className="text-sm text-gray-400 hover:text-white transition-colors block">
                    0212 912 67 97 (Ofis)
                  </a>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <div className="w-8 h-8 bg-[#DD0000]/20 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className="ri-mail-line text-[#FFCE00]"></i>
                </div>
                <a href="mailto:rotaberlinn@gmail.com" className="text-sm text-gray-400 hover:text-white transition-colors">
                  rotaberlinn@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-gray-800">
        <div className="container mx-auto px-6 py-6">
          <div className="flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-500">
            <div>© 2024 Rota Berlin. Tüm hakları saklıdır.</div>
            <div className="flex items-center gap-6">
              <a href="#" className="hover:text-[#FFCE00] transition-colors cursor-pointer">Gizlilik Politikası</a>
              <a href="#" className="hover:text-[#FFCE00] transition-colors cursor-pointer">Kullanım Şartları</a>
              <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#FFCE00] transition-colors">Powered by Readdy</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
